<div class="biz-page">

    <!-- Title + add -->
    <div class="rana-page-header">
        <div>
            <h1 class="rana-page-title">Business Directory</h1>
            <p class="rana-page-subtitle mb-0">
                Find businesses run by RANA members, get in touch, and learn from people who have done it before.
            </p>
        </div>
        <div class="text-right">
            <button class="btn btn-dark-primary" *ngIf="canAdd" (click)="openAdd()">
                <i class="uil uil-plus-circle mr-1"></i> Add Business
            </button>
            <a class="btn btn-dark-primary" *ngIf="!loggedIn" routerLink="/login">
                <i class="uil uil-signin mr-1"></i> Log in to list your business
            </a>
            <div class="size-13 text-muted mt-2" *ngIf="loggedIn && !canAdd">
                Only RANA members can add a business. You can browse, like, comment and get in touch.
            </div>
        </div>
    </div>

    <div class="biz-links mt-3">
        <a class="rana-action-btn mr-2 mb-1" routerLink="/biz-opportunities"><i class="uil uil-megaphone"></i> Opportunities board</a>
        <a class="rana-action-btn mb-1" routerLink="/biz-startup"><i class="uil uil-rocket"></i> Starting a business?</a>
    </div>

    <div class="alert alert-light border mt-3 mb-0" *ngIf="!loggedIn">
        <i class="uil uil-lock-alt"></i>
        Phone numbers, emails and social links are shown to logged-in visitors only.
        <a routerLink="/login">Log in</a> or <a routerLink="/register">register</a> to see them.
    </div>

    <!-- Spotlight + newly added (hidden while searching) -->
    <ng-container *ngIf="!filtersActive">
        <div class="biz-spotlight mt-4" *ngIf="spotlight">
            <div class="biz-section-label"><i class="uil uil-star"></i> Business of the month</div>
            <div class="row align-items-center">
                <div class="col-md-4 mb-3 mb-md-0">
                    <app-biz-card [biz]="spotlight" [chapterName]="chapterName(spotlight)"></app-biz-card>
                </div>
                <div class="col-md-8" *ngIf="spotlight.tagline || spotlight.memberOffer">
                    <p class="lead mb-2" *ngIf="spotlight.tagline">{{ spotlight.tagline }}</p>
                    <p class="mb-0" *ngIf="spotlight.memberOffer"><i class="uil uil-gift"></i> <strong>RANA member offer:</strong> {{ spotlight.memberOffer }}</p>
                </div>
            </div>
        </div>

        <div class="mt-4" *ngIf="newest.length">
            <div class="biz-section-label"><i class="uil uil-clock"></i> Newly added</div>
            <div #carousel class="biz-swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let b of newest">
                        <app-biz-card [biz]="b" [chapterName]="chapterName(b)"></app-biz-card>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Search + filters -->
    <div class="biz-filters mt-4">
        <div class="form-group position-relative mb-2">
            <input type="text" class="form-style big form-style-with-icon section-shadow-blue"
                   placeholder="Search by name, service, city or owner" [(ngModel)]="q" (input)="onTyping()">
            <i class="input-icon big uil uil-search"></i>
        </div>

        <div class="biz-chips mb-2">
            <button type="button" class="biz-chip" *ngFor="let g of groups" [class.active]="group === g.group"
                    (click)="pickGroup(g.group)">{{ g.group }}</button>
        </div>

        <div class="row">
            <div class="col-md-3 mb-2" *ngIf="group">
                <select class="form-style with-border" [(ngModel)]="industry" (change)="onFilterChange()">
                    <option value="">All in {{ group }}</option>
                    <option *ngFor="let c of groupCategories" [value]="c.code">{{ c.name }}</option>
                </select>
            </div>
            <div class="col-md-3 mb-2">
                <select class="form-style with-border" [(ngModel)]="state" (change)="onFilterChange()">
                    <option value="">Any state</option>
                    <option *ngFor="let s of states" [value]="s.code">{{ s.name }}</option>
                </select>
            </div>
            <div class="col-md-3 mb-2">
                <select class="form-style with-border" [(ngModel)]="chapterId" (change)="onFilterChange()">
                    <option value="">Any chapter</option>
                    <option *ngFor="let c of chapters" [value]="c.id">{{ c.name }}</option>
                </select>
            </div>
            <div class="col-md-3 mb-2">
                <select class="form-style with-border" [(ngModel)]="lookingFor" (change)="onFilterChange()">
                    <option value="">Looking for: anything</option>
                    <option *ngFor="let l of lookingForOptions" [value]="l.value">Looking for {{ l.label.toLowerCase() }}</option>
                </select>
            </div>
        </div>

        <div class="d-flex flex-wrap align-items-center biz-toggles">
            <label class="mr-3 mb-1"><input type="checkbox" [(ngModel)]="mentorOnly" (change)="onFilterChange()"> Mentors available</label>
            <label class="mr-3 mb-1"><input type="checkbox" [(ngModel)]="verifiedOnly" (change)="onFilterChange()"> Verified only</label>
            <label class="mr-3 mb-1" *ngIf="loggedIn"><input type="checkbox" [(ngModel)]="mineOnly" (change)="onFilterChange()"> My businesses</label>
            <label class="mr-3 mb-1" *ngIf="loggedIn"><input type="checkbox" [(ngModel)]="followingOnly" (change)="onFilterChange()"> Businesses I follow</label>
            <button type="button" class="rana-action-btn" *ngIf="filtersActive" (click)="clearFilters()">Clear filters</button>
            <span class="ml-auto d-flex align-items-center">
                <select class="form-style with-border mr-2 biz-sort" [(ngModel)]="sort" (change)="onFilterChange()">
                    <option value="newest">Newest</option>
                    <option value="name">A to Z</option>
                    <option value="popular">Most popular</option>
                </select>
                <span class="d-inline-flex" style="gap:6px">
                    <button type="button" class="rana-action-btn" [ngClass]="{'rana-action-btn-active': view === 'cards'}" (click)="view = 'cards'" title="Cards"><i class="uil uil-apps"></i></button>
                    <button type="button" class="rana-action-btn" [ngClass]="{'rana-action-btn-active': view === 'table'}" (click)="view = 'table'" title="Table"><i class="uil uil-list-ul"></i></button>
                </span>
            </span>
        </div>
    </div>

    <div class="size-14 text-muted mt-3 mb-2" *ngIf="loaded">
        {{ total }} business{{ total === 1 ? '' : 'es' }}{{ filtersActive ? ' match your search' : ' listed by RANA members' }}
    </div>

    <div *ngIf="loading && !loaded" class="d-flex justify-content-center py-5 text-muted">
        <i class="uil uil-spinner-alt spin-animation mr-2"></i>Loading businesses...
    </div>

    <div *ngIf="loaded && results.length === 0" class="rana-panel text-center py-5">
        <i class="uil uil-shop size-40 color-primary mb-2 d-block"></i>
        <strong class="d-block mb-1">{{ filtersActive ? 'No businesses match your search.' : 'No businesses listed yet.' }}</strong>
        <p class="mb-0 text-muted">{{ filtersActive ? 'Try fewer filters or a different word.' : 'Once members add businesses, they will appear here.' }}</p>
    </div>

    <!-- Cards -->
    <div class="row" *ngIf="view === 'cards' && results.length">
        <div class="col-md-6 col-xl-4 mb-3" *ngFor="let b of results | paginate: {itemsPerPage: pageSize, currentPage: page, totalItems: total}">
            <app-biz-card [biz]="b" [chapterName]="chapterName(b)"></app-biz-card>
        </div>
    </div>

    <!-- Table -->
    <div class="table-responsive" *ngIf="view === 'table' && results.length">
        <table class="table table-hover biz-table">
            <thead>
            <tr><th>Business</th><th>Category</th><th>Location</th><th>Chapter</th><th>Owner</th><th>Website</th></tr>
            </thead>
            <tbody>
            <tr *ngFor="let b of results | paginate: {itemsPerPage: pageSize, currentPage: page, totalItems: total}"
                [routerLink]="['/biz-directory', b.id]" style="cursor: pointer;">
                <td><strong>{{ b.businessName }}</strong> <i *ngIf="b.verified" class="uil uil-check-circle text-success" title="Verified"></i>
                    <div class="size-13 text-muted" *ngIf="b.tagline">{{ b.tagline }}</div></td>
                <td><span class="rana-badge rana-badge-accent">{{ category(b.industry) }}</span></td>
                <td>{{ location(b) }}</td>
                <td>{{ chapterName(b) }}</td>
                <td>{{ b.ownerName }}</td>
                <td><a *ngIf="b.website" [href]="b.website" target="_blank" rel="noopener" (click)="$event.stopPropagation()">{{ b.website }}</a></td>
            </tr>
            </tbody>
        </table>
    </div>

    <div class="d-flex justify-content-center mt-3" *ngIf="total > pageSize">
        <pagination-controls (pageChange)="onPageChange($event)"></pagination-controls>
    </div>

    <div class="rana-panel mt-4 d-flex flex-wrap align-items-center justify-content-between" *ngIf="loggedIn">
        <div class="mr-3">
            <strong>Weekly directory email</strong>
            <div class="size-13 text-muted">New businesses and member opportunities, once a week. Unsubscribe any time.</div>
        </div>
        <button type="button" [ngClass]="digestSubscribed ? 'rana-action-btn' : 'btn btn-dark-primary'" (click)="toggleDigest()">
            {{ digestSubscribed ? 'Unsubscribe' : 'Subscribe' }}</button>
    </div>
</div>
